import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    topupShort: '{{missing}} short — top up',
    bandJoinToOpen: 'Join SHOT BAND to open',
    bandInsufficientBonusButton: 'Not enough sparks',
    bandInsufficientBonusHint: 'Sparks are cashback for playing, not something you buy.',
  },
  ru: {
    topupShort: 'Не хватает {{missing}} — пополнить',
    bandJoinToOpen: 'Вступи в SHOT BAND',
    bandInsufficientBonusButton: 'Не хватает искр',
    bandInsufficientBonusHint: 'Искры не купишь — их даёт кешбэк за игру.',
  },
  uz: {
    topupShort: '{{missing}} yetmaydi — toʻldirish',
    bandJoinToOpen: 'SHOT BANDʼga qoʻshil',
    bandInsufficientBonusButton: 'Uchqunlar yetarli emas',
    bandInsufficientBonusHint: 'Uchqunlar — oʻyin uchun keshbek, sotib olinmaydi.',
  },
  fa: {
    topupShort: '{{missing}} کم است — شارژ کن',
    bandJoinToOpen: 'برای باز کردن به SHOT BAND بپیوند',
    bandInsufficientBonusButton: 'جرقه کم است',
    bandInsufficientBonusHint: 'جرقه کش‌بک بازی کردن است، خریدنی نیست.',
  },
  pt: {
    topupShort: 'Faltam {{missing}} — depositar',
    bandJoinToOpen: 'Entre no SHOT BAND',
    bandInsufficientBonusButton: 'Faíscas insuficientes',
    bandInsufficientBonusHint: 'Faíscas não se compram — vêm do cashback por jogar.',
  },
  tr: {
    topupShort: '{{missing}} eksik — yatır',
    bandJoinToOpen: "SHOT BAND'e katıl",
    bandInsufficientBonusButton: 'Yeterli kıvılcım yok',
    bandInsufficientBonusHint: 'Kıvılcım satın alınmaz — oyun için cashback olarak verilir.',
  },
});
